/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";
import * as actions from "../../../../../app/modules/SystemManagement/_redux/modules/ModulesAction";
import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";

export function AsideMenuList({ layoutProps }) {
  const location = useLocation();
  const dispatch = useDispatch();
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu &&
          "menu-item-active"} menu-item-open menu-item-not-hightlighted`
      : "";
  };

  const { modules } = useSelector(
    (state) => ({
      modules: state.modules.asideMenuList
    }),
    shallowEqual
  );
  
  useEffect(() => {
    dispatch(actions.getAsideMenuList());
    return () => dispatch(actions.cleanAsideMenuList());
  }, [dispatch]);
  
  // Ana Modüller
  const parentModules = modules.filter(module => module.parentId === 0);

  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/dashboard", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/dashboard">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")} />
            </span>
            <span className="menu-text">Dashboard</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}

        {
          parentModules.map(module => {            
            const childModules = modules.filter(childModule => childModule.parentId === module.id);

            if (childModules.length > 0) {
              return (
                /*begin::1 Level*/
                <li
                  key={module.key}
                  className={`menu-item menu-item-submenu ${getMenuItemActive(
                    "/" + module.key,
                    true
                  )}`}
                  aria-haspopup="true"
                  data-menu-toggle="hover"
                >
                  <NavLink className="menu-link menu-toggle" to={"/" + module.link}>
                    <span className="svg-icon menu-icon">
                      <SVG src={toAbsoluteUrl("/media/svg/icons/" + module.icon + ".svg")} />
                    </span>
                    <span className="menu-text">{module.name}</span>
                  </NavLink>
                  <div className="menu-submenu">
                    <i className="menu-arrow" />
                    <ul className="menu-subnav">
                      <li className="menu-item menu-item-parent" aria-haspopup="true">
                        <span className="menu-link">
                          <span className="menu-text">{module.name}</span>
                        </span>
                      </li>

                      {
                        childModules.map(module => (
                          /*begin::2 Level*/
                          <li
                            key={module.key}
                            className={`menu-item ${getMenuItemActive(
                              "/" + modules.link
                            )}`}
                            aria-haspopup="true"
                          >
                            <NavLink className="menu-link" to={"/" + module.link}>
                              <i className="menu-bullet menu-bullet-dot">
                                <span />
                              </i>
                              <span className="menu-text">{module.name}</span>
                            </NavLink>
                          </li>
                          /*end::2 Level*/
                        ))
                      }                        
                    </ul>
                  </div>
                </li>
                /* end::1 Level */                   
              )
            } else {
              return (
                /* begin::1 Level */
                <li
                  key={module.key}
                  className={`menu-item ${getMenuItemActive("/" + module.link, false)}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to={"/" + module.link}>
                    <span className="svg-icon menu-icon">
                      <SVG src={toAbsoluteUrl("/media/svg/icons/" + module.icon + ".svg")} />
                    </span>
                    <span className="menu-text">{module.name}</span>
                   </NavLink>
                </li>
                /* end::1 Level */
              )      
            }            
          })
        }
      </ul>
      {/* end::Menu Nav */}
    </>
  );
}